import React, { useEffect } from "react"
import Layout from "../components/Layout"
import Seo from "../components/Seo"
import "../css/faq.css"
import rightArrow from "../assets/images/listing-place/right-arrow.png"
import waveHeader from "../assets/images/listing-place/wave_header.png"
import "aos/dist/aos.css"
import AOS from "aos"
import FaqComp from "../components/Faq"
import { StaticImage } from "gatsby-plugin-image"

const Faq = () => {
  useEffect(() => {
    AOS.init({
      disable: false,
      startEvent: "DOMContentLoaded",
      initClassName: "aos-init",
      animatedClassName: "aos-animate",
      useClassNames: false,
      disableMutationObserver: false,
      debounceDelay: 100,
      throttleDelay: 99,
      offset: 120,
      delay: 0,
      duration: 1200,
      easing: "ease",
      once: false,
      mirror: false,
      anchorPlacement: "top-bottom",
    })
  }, [])

  return (
    <Layout>
      <Seo Sitetitle="Faq" />
      <section className="hero-section">
        <div className="container-fluid">
          <div className="row flex-column-reverse-mob">
            <div data-aos="fade-right" className="col-lg-4 add-padding-top">
              <h2 className="top-wraper-navigation">
                Home
                <img
                  src={rightArrow}
                  className="img-fluid mx-2"
                  alt="right-arrow"
                />
                <b>FAQ</b>
              </h2>
              <h2 className="hero-heading mt-3">Frequently Asked Questions</h2>
              <div className="hero-hr" />
            </div>
            <div
              data-aos="fade-up"
              className="col-lg-8 remove-padding-mob position-relative pr-lg-0"
            >
              <StaticImage
                src="../assets/images/faq/hero-img.jpg"
                placeholder="tracedSVG"
                className="img-fluid"
                alt="hero-img"
              />
              <img
                src={waveHeader}
                className="img-fluid wave-header-faq"
                alt="wave_header"
              />
            </div>
          </div>
        </div>
      </section>
      {/* <section className="tab-outer tab-1 position-relative">
        <div className="container sit-z-index">
          <FaqComp />
        </div>
      </section> */}
      <FaqComp />
    </Layout>
  )
}

export default Faq
